export const JS = "JS";
export const CSS = "CSS";
export const HTML = "HTML";
